<!--
 * @Description: 高级查询 学生
 * @Author: PF
 * @Date: 2023-01-29 11:37:55
 * @LastEditors: PF
 * @LastEditTime: 2025-05-13 14:04:49
-->
<template>
  <div class="cha-xun-xue-sheng">
    <el-drawer :model-value="openGaoJi" title="高级查询" direction="rtl" :before-close="handleClose">
      <el-table :data="tableData" :show-header="false">
        <el-table-column prop="sfzg" align="center" width="90">
          <template #default="scope">
            <el-select v-if="scope.$index !== 0" v-model="scope.row.yhgx">
              <el-option value="and" label="并且" />
              <el-option value="or" label="或者" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="zkh" align="center" width="65">
          <template #default="scope">
            <el-select v-model="scope.row.zkh" clearable filterable  >
              <el-option value='(' label="(" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="zd" align="center" show-overflow-tooltip :fit="true">
          <template #default="scope">
            <el-select v-model="scope.row.zd" placeholder=" " clearable filterable popper-class="gaoji-ziduan_xiala" @change="zdChange(scope.$index)">
              <el-option v-for="(item, index) in zdList" :key="index" :value='item.value' :label="item.label" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="pd" align="center" width="115px">
          <template #default="scope">
            <div v-for="(item,index) in zdList" :key="index">
              <div v-if="item.value === scope.row.zd">
                <el-select v-model="scope.row.pd" clearable filterable >
                  <el-option v-for="(val, i) in item.pd" :key="i" :value="val.value" :label="val.label" />
                </el-select>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="zhi" align="center" show-overflow-tooltip>
          <template #default="scope">
            <!-- 条件类型：[1]文本 [2]下拉框 [3]树形下拉框 [4]日期 -->
            <el-input v-model="scope.row.zhi" v-if="scope.row.tjlx === 1" :disabled="scope.row.pd === 'isNull' || scope.row.pd === 'isNotNull'" clearable />
            <el-select v-model="scope.row.zhi" v-if="scope.row.tjlx === 2" :disabled="scope.row.pd === 'isNull' || scope.row.pd === 'isNotNull'" clearable filterable >
              <el-option v-for="(item, index) in scope.row.neiRongList" :key="index" :value='item.value' :label="item.label" />
            </el-select>
            <el-cascader v-model="scope.row.zhi" :props="scope.row.neiRongProps" :options="scope.row.neiRongList" v-if="scope.row.tjlx === 3" :disabled="scope.row.pd === 'isNull' || scope.row.pd === 'isNotNull'" clearable filterable >
            </el-cascader>
            <el-date-picker v-model="scope.row.zhi" type="date" v-if="scope.row.tjlx === 4" :disabled="scope.row.pd === 'isNull' || scope.row.pd === 'isNotNull'" clearable filterable  />
          </template>
        </el-table-column>
        <el-table-column prop="ykh" align="center" width="65">
          <template #default="scope">
            <el-select v-model="scope.row.ykh" clearable filterable >
              <el-option value=')' label=")" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" width="90">
          <template #default="scope">
            <el-button class="w32" type="primary" @click="addGw(scope.$index)"><span class="iconfont icon-chuangjian"></span></el-button>
            <el-button class="w32" type="danger" v-if="tableData.length > 1" @click="delGw(scope.$index)"><span class="iconfont icon-jian"></span></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer-but mt10">
        <el-button type="success" @click="yanZheng()">查询</el-button>
        <el-button @click="chongZhi()">重置</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
import { warningPrompt } from '@/utils/promptInfo'
import { getXjzt } from '@/utils/meiju'
import { actionPost } from '@/api/common'
const props = defineProps({ openGaoJi: { type: Boolean, required: true }, row: { required: false } })
const emits = defineEmits(['update:openGaoJi', 'ReturnData'])

// [yhgx]与或关系 [zkh]左括号 [zd]字段 [pd]判断 [zhi]值 [ykh]右括号 [tjlx]条件类型（[1]文本 [2]下拉框 [3]树形下拉框 [4]日期）
const tableData = ref([
  { yhgx: null, zkh: null, zd: 'xh', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
  { yhgx: 'and', zkh: null, zd: 'xm', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
  { yhgx: 'and', zkh: null, zd: 'xslxdh', pd: 'like', zhi: null, ykh: null, tjlx: 1 }
])

/**
 * 条件列表
 * [lx]类型（[1]文本 [2]下拉框 [3]树形下拉框 [4]日期） [value]字段名 [xiaLa]下拉列表类型
 * [pd]判断（[equals]等于 [notEquals]不等于 [greater]大于 [less]小于 [greaterEqual]大于等于 [lessEqual]小于等于 [like]包含 [notLike]不包含 [isNull]等于空 [isNotNull]不等于空）
 */
const zdList = ref([
  { lx: 1, value: 'xh', label: '学号', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'like', label: '包含' }, { value: 'notLike', label: '不包含' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 1, value: 'xm', label: '姓名', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'like', label: '包含' }, { value: 'notLike', label: '不包含' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 1, value: 'xslxdh', label: '手机号', pd: [{ value: 'like', label: '包含' }, { value: 'notLike', label: '不包含' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 2, value: 'sfzjlxid', label: '身份证件类型', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 1, value: 'sfzjh', label: '身份证件号', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'like', label: '包含' }, { value: 'notLike', label: '不包含' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 1, value: 'zp', label: '照片', pd: [{ value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 2, value: 'njid', label: '年级', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'nianJi' },
  { lx: 2, value: 'bjid', label: '班级', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'banJi' },
  { lx: 2, value: 'xsdqzt', label: '学生当前状态', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'xsdqztDian' },
  { lx: 2, value: 'xb', label: '性别', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 4, value: 'csrq', label: '出生日期', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'greater', label: '大于' }, { value: 'less', label: '小于' }, { value: 'greaterEqual', label: '大于等于' }, { value: 'lessEqual', label: '小于等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 2, value: 'mzid', label: '民族', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'xxid', label: '血型', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'hyzkid', label: '婚姻状态', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'xyzjid', label: '宗教信仰', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'gwtqwid', label: '港澳台侨外', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'jkzkid', label: '健康状况', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'zzmmid', label: '政治面貌', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'rxfsid', label: '入学方式', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'xslyid', label: '学生来源', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'jdfsid', label: '就读方式', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'xslbid', label: '学生类别', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'gjdqid', label: '国籍/地区', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 2, value: 'hklbid', label: '户口类别', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'ziDian' },
  { lx: 4, value: 'bmrq', label: '报名日期', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'greater', label: '大于' }, { value: 'less', label: '小于' }, { value: 'greaterEqual', label: '大于等于' }, { value: 'lessEqual', label: '小于等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 4, value: 'rxrq', label: '入学日期', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'greater', label: '大于' }, { value: 'less', label: '小于' }, { value: 'greaterEqual', label: '大于等于' }, { value: 'lessEqual', label: '小于等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }] },
  { lx: 2, value: 'xqid', label: '校区', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'xiaoQu' },
  { lx: 2, value: 'zyid', label: '专业', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'zhuanYe' },
  { lx: 2, value: 'xbid', label: '系部', pd: [{ value: 'equals', label: '等于' }, { value: 'notEquals', label: '不等于' }, { value: 'isNull', label: '等于空' }, { value: 'isNotNull', label: '不等于空' }], xiaLa: 'xiBu' }
])

// 选择条件
const zdChange = (val) => {
  tableData.value.forEach((element, index) => {
    if (val === index) {
      element.zhi = null
      zdList.value.forEach((e) => {
        if (e.value === element.zd) {
          element.pd = e.pd[0].value
          element.tjlx = e.lx
          let obj = {}
          // 下拉菜单
          switch (e.xiaLa) {
            case 'ziDian': // 字典表
              obj = { url: '/api/v2/sys/zidian/list', data: { lx: e.label, order: 'sx', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.bt; return v })
              })
              break
            case 'xsdqztDian': // 学生当前状态
              element.neiRongList = getXjzt().list
              break
            case 'xiaoQu': // 校区
              obj = { url: '/api/v2/pdp/xiaoqu/list', data: { order: 'xqdm', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.xqmc; return v })
              })
              break
            case 'zhuanYe': // 专业
              obj = { url: '/api/v2/pdp/zhuanye/list', data: { order: 'zybh', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.zymc; return v })
              })
              break
            case 'xiBu': // 系部
              obj = { url: '/api/v2/xiaoneijigou/listxibu', data: { order: 'jgh', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.jgmc; return v })
              })
              break
            case 'nianJi': // 年级
              obj = { url: '/api/v2/pdp/nianji/list', data: { order: 'njdm', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.njmc; return v })
              })
              break
            case 'banJi': // 班级
              obj = { url: '/api/v2/pdp/banji/list', data: { order: 'xzbmc', sort: 'asc' } }
              actionPost(obj).then(res => {
                element.neiRongList = res.data.map((v) => { v.value = v.id; v.label = v.xzbmc; return v })
              })
              break
            default:
              element.neiRongList = null
              break
          }
          switch (e.label) {
            case '性别':
              element.neiRongList = [{ value: '男', label: '男' }, { value: '女', label: '女' }]
              break
          }
        }
      })
    }
  })
}
const addGw = (index) => {
  const obj = {
    yhgx: 'and',
    zkh: null,
    zd: null,
    pd: 'like',
    zhi: null,
    ykh: null,
    tjlx: 1
  }
  tableData.value.splice(index + 1, 0, obj)
}
const delGw = (index) => {
  tableData.value.splice(index, 1)
}
// 验证
const yanZheng = () => {
  const dataNew = []
  let kuohao = ''
  tableData.value.forEach((element) => {
    if (element.zhi || element.pd === 'isNull' || element.pd === 'isNotNull') {
      element.zhi = Array.isArray(element.zhi) ? element.zhi[element.zhi.length - 1] : element.zhi
      dataNew.push(element)
      kuohao = kuohao + element.zkh + element.ykh
    }
  })
  const kuohao1 = kuohao.replaceAll('null', '')
  const kuohao2 = kuohao1.replaceAll('()', '')
  if (kuohao2) {
    return warningPrompt('请补全括号')
  }
  chaXun(dataNew)
}
// 查询
const chaXun = (data) => {
  let tiaoJian = JSON.parse(JSON.stringify(data)) || []
  if (tiaoJian.length) {
    tiaoJian = tiaoJian.map(item => { delete item.neiRongList; delete item.neiRongProps; return item })
    tiaoJian[0].yhgx = null
  }
  emits('ReturnData', data)
}
// 重置
const chongZhi = () => {
  tableData.value = [
    { yhgx: null, zkh: null, zd: 'xh', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
    { yhgx: 'and', zkh: null, zd: 'xm', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
    { yhgx: 'and', zkh: null, zd: 'xslxdh', pd: 'like', zhi: null, ykh: null, tjlx: 1 }
  ]
  emits('ReturnData', [])
}
// 关闭
const handleClose = () => {
  emits('update:openGaoJi', false)
}
watch(
  () => props.openGaoJi,
  () => {
    if (props.openGaoJi) {
      tableData.value = Array.isArray(props.row)
        ? props.row
        : [
            { yhgx: null, zkh: null, zd: 'xh', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
            { yhgx: 'and', zkh: null, zd: 'xm', pd: 'equals', zhi: null, ykh: null, tjlx: 1 },
            { yhgx: 'and', zkh: null, zd: 'xslxdh', pd: 'like', zhi: null, ykh: null, tjlx: 1 }
          ]
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.cha-xun-xue-sheng {
  :deep(.el-drawer) {
    width: 50% !important;
    min-width: 770px;
  }
  :deep(.el-table .cell) {
    padding: 0 5px;
  }
  :deep(.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf) {
    border: none;
  }
  .el-select,
  :deep(.el-input) {
    width: 100%;
  }
  :deep(.el-table__inner-wrapper::before) {
    height: 0;
  }
  .footer-but {
    display: flex;
    justify-content: center;
    .el-button {
      width: 150px;
      height: 35px;
    }
  }
}
</style>
